import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  DataAnnotationAdditionalSection,
  DataAnnotationPatientProfile,
  Observations,
  QuestionnaireTO,
  SurveyTO,
} from '../../lib';

interface DataAnnotationState {
  dataAnnotationPatientProfile: DataAnnotationPatientProfile;
  additionalSection: DataAnnotationAdditionalSection;
  observations: Observations;
  surveys: SurveyTO[];
  currentQuestionnaire: QuestionnaireTO;
  resolvingSubmitCount: number;
}

const initialState: DataAnnotationState = {
  currentQuestionnaire: {} as QuestionnaireTO,
  dataAnnotationPatientProfile: {},
  additionalSection: {},
  surveys: [],
  observations: {},
  resolvingSubmitCount: 0,
};

interface QuestionnairePayload {
  currentQuestionnaire: QuestionnaireTO;
}

interface DataAnnotationPayload {
  dataAnnotationPatientProfile: DataAnnotationPatientProfile;
  additionalSection: DataAnnotationAdditionalSection;
  observations: Observations;
  surveys: SurveyTO[];
}

export const dataAnnotationSlice = createSlice({
  name: 'dataAnnotation',
  initialState,
  reducers: {
    setDataAnnotationData(state, action: PayloadAction<DataAnnotationPayload>) {
      state.dataAnnotationPatientProfile =
        action.payload.dataAnnotationPatientProfile;
      state.additionalSection = action.payload.additionalSection;
      state.observations = action.payload.observations;
      state.surveys = action.payload.surveys;
    },
    setCurrentQuestionnaire(
      state,
      action: PayloadAction<QuestionnairePayload>,
    ) {
      state.currentQuestionnaire = action.payload.currentQuestionnaire;
    },
    increaseResolvingSubmitCount(state) {
      state.resolvingSubmitCount += 1;
    },
    resetResolvingSubmitCount(state) {
      state.resolvingSubmitCount = 0;
    },
  },
});

export const {
  setDataAnnotationData,
  setCurrentQuestionnaire,
  increaseResolvingSubmitCount,
  resetResolvingSubmitCount,
} = dataAnnotationSlice.actions;
